import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	logoAltText: {
		id: 'fastshift-portal.domain-scoped-page.customer-name-and-logo.logo-alt-text',
		defaultMessage: '{name} logo',
		dsecription: 'Alt Text for company logo icon for the selected customer',
	},
});
